import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";
export const metadata: FigureMetadata = {
  id: "LITPROF",
  title: defineMessage({
    id: "fig.learning.LITPROF.title",
    defaultMessage: `Adult education by literacy proficiency level`,
  }),
  caption: defineMessage({
    id: "fig.learning.LITPROF.caption",
    defaultMessage: `Many literates have low levels of proficiency.`,
  }),
  source: defineMessage({
    id: "fig.learning.LITPROF.source",
    defaultMessage: `PIAAC and STEP surveys`,
  }),
};
